<template lang="html">
  <div class="container mx-auto px-4 py-8">
    <h1 class="mb-2 text-3xl font-semibold">
      Блог
    </h1>
    <p v-if="tag" class="mb-8 text-sm text-neutral-500">
      Тег «{{ tag }}» ·
      <NuxtLink to="/blog" class="hover:underline">Показать все</NuxtLink>
    </p>
    <div v-else class="mb-8" />

    <ContentFeedList
      :items="collection"
      :pending="pending"
      base-path="/blog"
      empty-text="Статей пока нет."
      :next-href="nextHref"
      @load-more="loadMore"
    />
  </div>
</template>

<script setup lang="ts">
import { ContentType } from '@repo/api/web/models'

import ContentFeedList from '../../components/Listing/ContentFeedList.vue'

definePageMeta({
  name: 'BlogIndex',
})

const { collection, pending, nextHref, tag, loadMore } = await useContentFeed({
  type: ContentType.ARTICLE,
  listKey: 'blog-list',
})

useContentListSeo({ feedTitle: 'Блог', descriptionBase: 'Статьи блога', tag })
</script>
